/**
 * Transfer errors in plain words (UI/UX fix round A, review A16): an item Azure refused because another client holds a
 * lease (a lock) on it leads with what to do — the service's own sentence stays available under the item's details.
 */
export const LEASE_NEXT_STEP = 'This item is locked by another program (a lease). Retry after that program releases it.';

export function isLeaseError(error: { code?: string; message: string }): boolean {
  return /^Lease/u.test(error.code ?? '') || /\blease\b/iu.test(error.message);
}
